import * as Sentry from '@sentry/nuxt'

Sentry.init({
  dsn: process.env.NODE_ENV === 'production' ? 'https://aa589eae4a04744040ec2ea9fb39484a@o4506774548119552.ingest.us.sentry.io/4506906162429952' : '',
  tracesSampleRate: 0.1,
  environment: process.env.NODE_ENV,
})
